var _circle, _ellipse, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoinStackRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.66
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    transform: "rotate(-90 28 28)",
    fill: "url(#paint0_radial_1554_26261)"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.9996,
    cy: 27.9978,
    rx: 15.2834,
    ry: 15.484,
    transform: "rotate(-90 27.9996 27.9978)",
    fill: "url(#paint1_linear_1554_26261)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.62
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9972 11.1676C37.4251 11.1676 45.0568 18.7098 45.0568 27.9998C45.0568 37.2899 37.4251 44.832 27.9972 44.832C18.5692 44.832 10.9375 37.2899 10.9375 27.9998C10.9375 18.7098 18.5692 11.1676 27.9972 11.1676Z",
    stroke: "#7551FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1429 32.1284C24.1593 32.1284 24.252 32.122 24.4127 31.9463C24.5728 31.7714 24.7463 31.4826 24.905 31.0723C25.2208 30.2563 25.4292 29.0872 25.4292 27.7652C25.4292 26.4432 25.2208 25.2741 24.905 24.4581C24.7463 24.0478 24.5728 23.7591 24.4127 23.5841C24.252 23.4084 24.1593 23.4021 24.1429 23.4021C24.1265 23.4021 24.0339 23.4084 23.8731 23.5841C23.7131 23.7591 23.5395 24.0478 23.3808 24.4581C23.0651 25.2741 22.8566 26.4432 22.8566 27.7652C22.8566 29.0872 23.0651 30.2563 23.3808 31.0723C23.5395 31.4826 23.7131 31.7714 23.8731 31.9463C24.0339 32.122 24.1265 32.1284 24.1429 32.1284ZM24.1429 33.375C23.6265 33.375 23.2116 33.1023 22.9106 32.7733C22.609 32.4436 22.3668 32.0021 22.1764 31.51C21.7938 30.5213 21.5703 29.1972 21.5703 27.7652C21.5703 26.3333 21.7938 25.0092 22.1764 24.0204C22.3668 23.5283 22.609 23.0868 22.9106 22.7571C23.2116 22.4281 23.6265 22.1555 24.1429 22.1555H26.7155H29.2881H31.8607C32.3771 22.1555 32.7921 22.4281 33.093 22.7571C33.3946 23.0868 33.6369 23.5283 33.8273 24.0204C34.2098 25.0092 34.4333 26.3333 34.4333 27.7652C34.4333 29.1972 34.2098 30.5213 33.8273 31.51C33.6369 32.0021 33.3946 32.4436 33.093 32.7733C32.7921 33.1023 32.3771 33.375 31.8607 33.375H29.2881H26.7155H24.1429ZM26.7155 32.1284C26.7319 32.1284 26.8246 32.122 26.9853 31.9463C27.1454 31.7714 27.3189 31.4826 27.4777 31.0723C27.7934 30.2563 28.0018 29.0872 28.0018 27.7652C28.0018 26.4432 27.7934 25.2741 27.4777 24.4581C27.3189 24.0478 27.1454 23.7591 26.9853 23.5841C26.8246 23.4084 26.7319 23.4021 26.7155 23.4021H25.8255C25.9308 23.5947 26.0252 23.8026 26.1094 24.0204C26.492 25.0092 26.7155 26.3333 26.7155 27.7652C26.7155 29.1972 26.492 30.5213 26.1094 31.51C26.0252 31.7278 25.9308 31.9357 25.8255 32.1284H26.7155ZM28.3981 32.1284H29.2881C29.3045 32.1284 29.3972 32.122 29.5579 31.9463C29.718 31.7714 29.8915 31.4826 30.0503 31.0723C30.366 30.2563 30.5744 29.0872 30.5744 27.7652C30.5744 26.4432 30.366 25.2741 30.0503 24.4581C29.8915 24.0478 29.718 23.7591 29.5579 23.5841C29.3972 23.4084 29.3045 23.4021 29.2881 23.4021H28.3981C28.5034 23.5947 28.5978 23.8026 28.6821 24.0204C29.0646 25.0092 29.2881 26.3333 29.2881 27.7652C29.2881 29.1972 29.0646 30.5213 28.6821 31.51C28.5978 31.7278 28.5034 31.9357 28.3981 32.1284ZM30.9707 32.1284H31.8607C31.8772 32.1284 31.9698 32.122 32.1305 31.9463C32.2906 31.7714 32.4641 31.4826 32.6229 31.0723C32.9386 30.2563 33.147 29.0872 33.147 27.7652C33.147 26.4432 32.9386 25.2741 32.6229 24.4581C32.4641 24.0478 32.2906 23.7591 32.1305 23.5841C31.9698 23.4084 31.8772 23.4021 31.8607 23.4021H30.9707C31.076 23.5947 31.1704 23.8026 31.2547 24.0204C31.6372 25.0092 31.8607 26.3333 31.8607 27.7652C31.8607 29.1972 31.6372 30.5213 31.2547 31.51C31.1704 31.7278 31.076 31.9357 30.9707 32.1284Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1554_26261",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28 28) rotate(90) scale(28)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#610CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#080015",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1554_26261",
    x1: 9.8649,
    y1: 46.0013,
    x2: 33.0494,
    y2: 25.7267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6B0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7551FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinStackRight);
export default __webpack_public_path__ + "static/media/CoinStackRight.6631a6d451144fcdf5e1e305650ba97c.svg";
export { ForwardRef as ReactComponent };